import { sharedAtlas } from './asset-store';

class AtlasSignal {
  generation = $state(0);

  constructor() {
    sharedAtlas.subscribe(() => {
      this.generation += 1;
    });
    void sharedAtlas.load().then(() => {
      this.generation += 1;
    });
  }
}

export const atlasSignal = new AtlasSignal();
